import React, { FC } from "react";

import { Chip, Stack, Typography } from "@components/base";

const Chips: FC = () => (
  <Stack spacing={4}>
    <Typography variant="h2">Chip</Typography>
    <Typography variant="subtitle2">Outlined</Typography>
    <Stack direction="row" spacing={2}>
      <Chip label="blue1" color="blue1" />
      <Chip label="blue2" color="blue2" />
      <Chip label="orange1" color="orange1" />
      <Chip label="orange2" color="orange2" />
      <Chip label="orange3" color="orange3" />
      <Chip label="brown" color="brown" />
      <Chip label="yellow" color="yellow" />
      <Chip label="green" color="green" />
      <Chip label="teal" color="teal" />
      <Chip label="purple1" color="purple1" />
      <Chip label="purple2" color="purple2" />
      <Chip label="purple3" color="purple3" />
      <Chip label="pink" color="pink" />
      <Chip label="grey" color="grey" />
    </Stack>
    <Typography variant="subtitle2">Filled</Typography>
    <Stack direction="row" spacing={2}>
      <Chip label="success" color="success" variant="filled" size="medium" />
      <Chip label="warning" color="warning" variant="filled" size="medium" />
      <Chip label="default" color="default" variant="filled" size="medium" />
      <Chip label="error" color="error" variant="filled" size="medium" />
    </Stack>
  </Stack>
);

export default Chips;
